import { render, staticRenderFns } from "./ResultadoCambio.vue?vue&type=template&id=6f384874&scoped=true&"
import script from "./ResultadoCambio.vue?vue&type=script&lang=js&"
export * from "./ResultadoCambio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f384874",
  null
  
)

export default component.exports